<div class="free-match-card-wrapper">
  @if (showCountPill()) {
    <div class="count-pill" [ngStyle]="countPillStyles | theme">
      <span [ngStyle]="countPillLabelStyles | theme">{{ countLabel() }}</span>
    </div>
  }
  <div
    role="button"
    class="free-match-card"
    [ngClass]="{ disabled: isDisabled() }"
    [ngStyle]="cardStyle | theme"
    [style.padding-top]="topPadding"
    [style.padding-bottom]="bottomPadding"
    [style.padding-left]="leftPadding"
    [style.padding-right]="rightPadding"
    (keydown.enter)="onClick()"
    (keydown.space)="onClick()"
    (click)="onClick()"
    [attr.tabindex]="isDisabled() ? -1 : 0"
    [attr.aria-disabled]="isDisabled()"
    [attr.aria-label]="ariaLabel()"
  >
    @if (splicedBg) {
      <app-spliced-background
        [image]="splicedBg.imageUrl"
        [cornerSize]="splicedBg.cornerSize"
        [disabled]="isDisabled()"
      />
    }
    @if (hasWaitingOpponent() && !isDisabled()) {
      <app-icon
        icon="player-waiting"
        [colorCss]="playerWaitingColor"
        sizeCss="--icon-medium"
        class="player-waiting-icon"
      />
    }
    <div [ngStyle]="titleStyles | theme">
      {{ title }}
    </div>
    <app-wager-prize
      [primary]="primaryPrizeAmount()"
      [secondary]="secondaryPrizeAmount()"
      [textStyles]="prizeStyles()"
      [shadowStyles]="prizeShadowStyles"
    />
    <app-wager-entry-line
      [prefix]="entryLabel"
      [prefixStyles]="enterStyle"
      [primary]="primaryEntryAmount()"
      [secondary]="secondaryEntryAmount()"
      [feeStyles]="feeStyle"
      [struck]="true"
    >
      <div [ngStyle]="freeStyle | theme">
        {{ freeLabel }}
      </div>
    </app-wager-entry-line>
    <div class="play-button" [ngStyle]="playButtonStyles | theme">
      @if (splicedPlayBg) {
        <app-spliced-background
          [image]="splicedPlayBg.imageUrl"
          [cornerSize]="splicedPlayBg.cornerSize"
        />
      }
      <span [ngStyle]="playButtonLabelStyles | theme">{{ playLabel }}</span>
    </div>
    <div class="expiry-label">
      <app-icon
        icon="stopwatch"
        colorCss="--card-free-match-label-expiry-icon-fill"
        sizeCss="--icon-medium"
      />
      <span [ngStyle]="expiryLabelStyles | theme">{{ expiresIn() }}</span>
    </div>
  </div>
</div>
